import { Nurse } from './nurse';
import { Patient } from './patient';
// 対話ステータス
export const TALK_STATUS_TYPES = {
  NEW_PAYING: '新規支払い中',
  APPLYING: '申込中',
  PREPARING: '準備中',
  DOING: '対話中',
  PENDING: '継続判定待ち',
  CONTINUED_PAYING: '継続支払い中',
  WAIT_FEEDBACK: 'フィードバック待ち',
  DONE: '終了',
  FORCE_END: '強制終了',  // 検索用の特殊ステータス: 'DONE' && is_force_end == true
  CANCELED: 'キャンセル',
};
// TalkStatusBadge コンポーネント用のテーマ設定
export const TALK_STATUS_BADGE_THEME = {
  ACTIVE: {
    COLOR: '#1b5e20',          // 濃い緑（対話中）
    BORDER: '#1b5e20',         // 枠線の色
    BORDER_LEFT: '#1b5e20'     // 左枠線の色
  },
  INACTIVE: {
    COLOR: '#616161',          // グレー（待機中）
    BORDER_BOTTOM: '#9e9e9e'   // 下線の色
  }
};
// 対話ルーム用のテーマ設定
export const TALK_ROOM_THEME = {
  BACKGROUND: '#e3f2fd',      // 薄い青色の背景
  BORDER: '#bbdefb',          // 青色のボーダー
  DARK: '#1976d2'             // 濃い青色 - テキストやアクセント用
};
// クーポン用のテーマ設定
export const COUPON_CHIP_THEME = {
  BACKGROUND: '#fff9c4',      // 薄い黄色の背景
  BACKGROUND_HOVER: '#ffeb3b', // ホバー時の背景色（より濃い黄色）
  COLOR: '#f57f17',           // オレンジ系のテキスト色
  BORDER: '#f9a825'           // 枠線の色
};
// MUIのChipコンポーネントで使用可能なcolor値の型定義
export type ChipColorType = 'success' | 'info' | 'default' | 'warning' | 'primary' | 'error' | 'secondary';
// ステータスごとのスタイル定義（MUIのcolor値またはカスタムスタイル）
export type StatusStyle = {
  chipColor?: ChipColorType;  // MUIのcolor値（オプション）
  customStyle?: {              // カスタムスタイル（オプション）
    backgroundColor: string;
    color: string;
    borderColor?: string;
  };
};
// TalkRoomCard/TalkRoomTableRow用の対話ステータスごとのスタイル定義
export const TALK_STATUS_STYLES: Record<string, StatusStyle> = {
  DOING: { chipColor: 'success' },
  WAIT_FEEDBACK: { chipColor: 'info' },
  DONE: { chipColor: 'default' },
  NEW_PAYING: { chipColor: 'warning' },
  APPLYING: { chipColor: 'primary' },
  CANCELED: {
    customStyle: {
      backgroundColor: '#f8e0e0',
      color: '#9e454e',
      borderColor: '#f8e0e0'
    }
  },
  PREPARING: { chipColor: 'info' },
  PENDING: { chipColor: 'warning' },
  CONTINUED_PAYING: { chipColor: 'warning' },
  FORCE_END: { chipColor: 'error' }
};

// 対話ルーム
export interface TalkRoom {
  id: number;
  parent_id: number; // 看護師ID
  child_id: number;  // 患者ID
  talk_status: keyof typeof TALK_STATUS_TYPES;
  chatroom_id?: string | null; // FirestoreのチャットルームID
  // 関連オブジェクト
  nurse?: Nurse;
  patient?: Patient;
  // TalkSessionから取得する情報
  price?: number;
  period_days?: number;
  start_at?: string;
  end_at?: string | null;
  last_chat_send_at?: string | null;
  rating?: number; // 評価（1〜5）
  rating_comment?: string | null; // 評価コメント
  rated_at?: string | null; // 評価日時
  request_at?: string | null; // 申込日時
  last_chat_message?: string | null; // 最終メッセージ内容
  last_chat_send_user_id?: string | null; // 最終メッセージ送信者ID
  is_force_end?: boolean; // 強制終了されたかどうか
  // 関連する対話セッション（APIレスポンスにより存在しない場合もある）
  sessions?: TalkSession[];
  // 管理情報
  created_at: string;
  updated_at: string;
}

// 対話セッション
export interface TalkSession {
  id: number;
  talk_room_id: number;
  price: number;
  period_days: number;
  start_at: string;
  end_at: string | null;
  discarded_at: string | null;
  coupon_id?: number | null;
  coupon_code?: string | null;
  coupon_name?: string | null;
  coupon_discount_amount?: number | null;
  // 管理情報
  created_at: string;
  updated_at: string;
}

// 対話一覧のレスポンス型（従来型、互換性のために残す）
export interface TalkRoomListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: TalkRoom[];
}

// 対話のレスポンス型
export interface TalkRoomSummaryResponse {
  nurse: Nurse | null;
  patient: Patient | null;
  talk_rooms: TalkRoom[];
}

// 対話検索パラメータ
export interface TalkSearchParams {
  page?: number;
  page_size?: number;
  search?: string;
  nurse_search?: string; // 看護師名検索
  patient_search?: string; // 患者名検索
  talk_status?: string | string[]; // 対話ステータス
  price?: number | number[]; // 価格フィルター（複数選択対応）
  ordering?: string; // ソート順
}
